const PREFIX = 'aiAssistant.meetingSummary.form.messages.mediaRejected';
const DEFAULT_MIN_DURATION_SECONDS = 300;
const BYTES_PER_MB = 1024 * 1024;

const toMb = (bytes) => Math.round((bytes / BYTES_PER_MB) * 10) / 10;

/**
 * 將後端結構化的媒體退回原因轉成在地化訊息。
 * 後端逐檔回報 code 與實測值，前端只負責翻譯與排版。
 * @param {Object} rejection - 後端的 detail 物件 { code, files, min_duration_seconds, ... }
 * @param {Function} t - 翻譯函數
 * @returns {string} 可直接顯示的訊息
 */
export function describeMediaRejection(rejection, t) {
  const minDurationMinutes = Math.round(
    (rejection.min_duration_seconds ?? DEFAULT_MIN_DURATION_SECONDS) / 60
  );
  const minSizeMb = rejection.min_file_size_bytes != null ? toMb(rejection.min_file_size_bytes) : '';
  const files = Array.isArray(rejection.files) ? rejection.files : [];
  const fallback = rejection.message || t(`${PREFIX}.fallback`);

  if (files.length === 0) {
    return t(`${PREFIX}.${rejection.code}`, {
      defaultValue: fallback,
      minDurationMinutes,
      minSizeMb,
    });
  }

  return files
    .map((file) =>
      t(`${PREFIX}.${file.code}`, {
        defaultValue: fallback,
        name: file.name || file.path,
        // 不足一分鐘時直接顯示秒數，避免「0 分鐘」這種無意義的說法
        duration:
          file.duration_seconds != null
            ? t(`${PREFIX}.durationSeconds`, { count: file.duration_seconds })
            : '',
        sizeMb: file.size_bytes != null ? toMb(file.size_bytes) : '',
        minDurationMinutes,
        minSizeMb,
      })
    )
    .join('\n');
}
